import Loadable from '../../components/loadable';

const ManageMfaChannels = Loadable({
  loader: () => import('../../components/mfa/manage_mfa_channels'),
});

angular.module('shared').value('ManageMfaChannels', ManageMfaChannels);
